<template>
  <j-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="false">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('公告类型')" prop="announceSecondName">
                <a-select v-model="model.announceSecondName" :placeholder="$t('请选择公告类型')" :disabled="disableSubmit">
                  <!-- 新闻资讯 -->
                  <a-select-option value="新闻资讯">{{ $t('新闻资讯') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('公告标题')" prop="announceTitle">
                <a-input v-model="model.announceTitle" :placeholder="$t('请输入公告标题')" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('填报部门')">
                <j-select-depart v-model="model.departId" :multi="false" @change="departChange" :disabled="disableSubmit"></j-select-depart>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('公告内容')" prop="content">
                <j-editor v-model="model.content" :disabled="disableSubmit"></j-editor>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('通告对象类型')" prop="msgType">
                <a-select v-model="model.msgType" :placeholder="$t('请选择通告对象类型')" :disabled="disableSubmit">
                  <a-select-option :value="0">{{ $t('指定用户') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('全体用户') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('优先级')" prop="priority">
                <a-select v-model="model.priority" :placeholder="$t('请选择优先级')" :disabled="disableSubmit">
                  <a-select-option value="低">{{ $t('低') }}</a-select-option>
                  <a-select-option value="中">{{ $t('中') }}</a-select-option>
                  <a-select-option value="高">{{ $t('高') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" v-if="model.msgType == 0">
              <a-form-model-item :label="$t('指定用户')" prop="userIds">
                <j-select-user-by-dep v-model="model.userIds" @change="sendChange" :isGg="true" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('附件')">
                <JUpload v-model="fileList" @change="uploadChange" :buttonVisible="false" v-if="disableSubmit"/>
                <JUpload v-model="fileList" @change="uploadChange" v-else/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JEditor from '@/components/jeecg/JEditor'
  import JSelectDepart from '@/components/jeecgbiz/JSelectDepart'
  import JSelectUserByDep from "@/components/jeecgbiz/JSelectUserByDep"
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {
      JUpload,
      JEditor,
      JSelectDepart,
      JSelectUserByDep
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-oa/notice/bsAnnounce/add",
          edit: "/jeecg-oa/notice/bsAnnounce/edit",
          queryById: "/jeecg-oa/notice/bsAnnounce/queryById",
        },
        fileList: []
      }
    },
    computed: {
      validatorRules() {
        return {
          announceSecondName: [{
            required: true,
            message: this.$t('请选择公告类型'),
            trigger: 'change'
          }],
          msgType:[{
              required: true,
              message: this.$t('请选择通告对象类型'),
              trigger: 'change'
          }],
          priority:[{
              required: true,
              message: this.$t('请选择优先级'),
              trigger: 'change'
          }],
          userIds:[{
              required: true,
              message: this.$t('请选择指定用户'),
              trigger: 'change'
          }],
          announceTitle:[{
              required: true,
              message: this.$t('请输入公告标题'),
              trigger: 'blur'
          }],
          content:[{
              required: true,
              message: this.$t('请输入公告内容'),
              trigger: 'blur'
          }],
        };
      },
    },
    methods: {
      departChange(ids,names){
        this.$set(this.model,'departName',names);
      },
      sendChange(ids,names){
        this.$set(this.model,'userNames',names);
      },
      uploadChange(file){
        this.$set(this.model,'files',file);
      },
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if (this.model.files == null) {
          this.fileList = []
        } else {
          this.fileList = [this.model.files];
        }
        if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else if(type == 'detail'){
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }else{
          this.title = this.$t('新增');
          this.disableSubmit = false;
          this.model.announceFirstType = 2;
        }
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      handleOk(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      }
    }
  }
</script>